import React from 'react';
import PropTypes from 'prop-types';
import { VelocityComponent } from 'velocity-react';
import 'velocity-animate/velocity.ui';

const defaultProps = {
  animation: 'transition.fadeIn',
  runOnMount: true,
  targetQuerySelector: null,
  interruptBehavior: 'stop',
  visibility: 'visible',
  duration: 300,
  delay: 50,
  easing: [0.4, 0.0, 0.2, 1],
  display: null,
  setRef: undefined,
};

const FuseAnimate = React.forwardRef(function FuseAnimate(props, ref) {
  const children = React.cloneElement(props.children, {
    style: {
      ...props.children.style,
      visibility: 'hidden',
    },
  });
  return (
    <VelocityComponent ref={ref} {...{ ...defaultProps, ...props }}>
      {children}
    </VelocityComponent>
  );
});

FuseAnimate.propTypes = {
  children: PropTypes.element.isRequired,
};


export default React.memo(FuseAnimate);
